import { DetailsVariant } from "components/entity-details/BaseDetails";
import { BroadcastResponseDetails } from "components/entity-details/BroadcastResponseDetails";
import { Spinner } from "components/spinners/Spinner";
import { FeaturedVideoType, SelectFeaturedTrailerBaseProps } from ".";

export const FeaturedTrailerInput = ({
    disabled,
    disabledVariant,
    featuredVideoType = FeaturedVideoType.VideoPlayer,
    selectedBroadcast,
    selectedBroadcastLoading
}: SelectFeaturedTrailerBaseProps) => {
    if (selectedBroadcastLoading) {
        return <Spinner />;
    }

    return (
        <BroadcastResponseDetails
            broadcast={selectedBroadcast}
            allowVideoPlaybackOnThumbnailClick={!disabled}
            location={"player-playlist"}
            disabled={disabled}
            disabledVariant={disabledVariant}
            variant={
                featuredVideoType == FeaturedVideoType.Catalog
                    ? DetailsVariant.Vertical
                    : DetailsVariant.Horizontal
            }
        />
    );
};
